'use strict';
var React = require('react');
var BfgAgentBox = require('./agentBox.js');
var FormatMessage = require('react-globalize').FormatMessage;

var SectionAgent = React.createClass({

    componentDidMount() {
        this.props.logPageView();
    },

    /**
     * @return {object}
     */
    render: function () {
        return (
            <section id="section4" className="content-section  about-section sectionPage">
                <div className="row">
                    <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
                        <div className="title-v1">
                            <div className="row">
                                <div className="col-sm-12   col-xs-12">
                                    <h1 className="text-center"><FormatMessage locale={this.props.locale}
                                                                               path="agentPage/agentPageTitle"/></h1>
                                    <hr className="small"/>
                                    <p><FormatMessage locale={this.props.locale}
                                                      path="agentPage/agentPageDescription1"/><br/></p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 col-xs-10 col-xs-offset-1">
                                <ul className="list-unstyled lists-v2">
                                    <li><i className="fa fa-circle-o"></i><FormatMessage locale={this.props.locale}
                                                                                         path="agentPage/agentPageList1"/>
                                    </li>
                                    <li><i className="fa fa-circle-o"></i><FormatMessage locale={this.props.locale}
                                                                                         path="agentPage/agentPageList2"/>
                                    </li>
                                    <li><i className="fa fa-circle-o"></i><FormatMessage locale={this.props.locale}
                                                                                         path="agentPage/agentPageList3"/>
                                    </li>
                                    <li><i className="fa fa-circle-o"></i><FormatMessage locale={this.props.locale}
                                                                                         path="agentPage/agentPageList4"/>
                                    </li>
                                    <li><i className="fa fa-circle-o"></i><FormatMessage locale={this.props.locale}
                                                                                         path="agentPage/agentPageList5"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <p><FormatMessage locale={this.props.locale} path="agentPage/agentPageDescription2"/><br/>
                            </p>
                            <row id="bfgAgentForm">
                                <BfgAgentBox url='/api/agents' locale={this.props.locale}/>
                            </row>
                        </div>
                        <row>
                            <div className="col-md-10 col-md-offset-1"><FormatMessage locale={this.props.locale}
                                                                                      path="agentPage/agentPageDescription3"/>&nbsp;
                                <a target="_blank" href="./documents/Prequal.pdf"><FormatMessage
                                    locale={this.props.locale} path="agentPage/agentPageLink"/></a> <FormatMessage
                                    locale={this.props.locale} path="agentPage/agentPageDescription4"/> <span
                                    className="font18">800-383-1709</span>.
                            </div>
                        </row>
                    </div>
                </div>
            </section>
        )
    }

});


module.exports = SectionAgent



// WEBPACK FOOTER //
// ./js/sectionAgent.js